import React, { FC } from 'react';
import { FontColor, Headline2, Headline4 } from '../../../Text';
import { FlexboxVertical } from '../../../Layout';
import styled from 'styled-components';
import { MetaInfoPanel } from './MetaInfoPanel';
import { PaymentConditionsPanel } from './PaymentConditionsPanel';
import { Product } from '../../../../../interfaces/Product';
import { parseProductColorSet } from '../../icons/ProductIconWrapper';

const MetaInfoWrapper = styled(FlexboxVertical)`
  margin: .25rem 0 2.5rem;
  
  ${Headline2}, ${Headline4} {
    text-align: start;
    margin-bottom: 1.25rem;
  }
`;

interface Props {
  product?: Product;
  visible?: boolean;
}
export const ProductDetailMetaInfoSection: FC<Props> = ({ product, visible = true, ...props }) => {
  const accentColor = parseProductColorSet(product?.metaProduct?.colorSet);
  return (
    <MetaInfoWrapper>
      <FontColor color={accentColor}><Headline2>{ product?.metaProduct?.productFeatures?.title }</Headline2></FontColor>

      <MetaInfoPanel product={product} />
      <PaymentConditionsPanel product={product} visible={visible} />

    </MetaInfoWrapper>
  );
}
